import { object } from '@gogame/schemas';

export const screenSchema = object({});
